module.exports = __webpack_public_path__ + "1fefa87db653a80ba8b737a1e76088d7.svg";